import angular from 'angular';
import ToggleSwitcher from '@sdk/components/forms/Switcher.tsx';

import { AttachmentsPreview } from '@web/components/AttachmentsPreview/AttachmentsPreview.tsx';
import QuotedMessagePreviewAngular from '@web/conversations/Conversation/QuotedMessagePreview/QuotedMessagePreviewAngular.tsx';
import AnnualPlanAnnouncementAngular from '@web/account/AnnualPlanAnnouncement/AnnualPlanAnnouncementAngular';
import ICalAnnouncementAngular from '@web/shifts/ICalAnnouncement/ICalAnnouncementAngular';
import { FoldableSearchAngularWrapper } from '@web/components/FoldableSearch/FoldableSearchAngularWrapper';
import { FoldableSearchBroadenAngularWrapper } from '@web/components/FoldableSearchBroaden/FoldableSearchBroadenAngularWrapper';
import EditPaymentButton from '@web/account/billing/EditPaymentButton/EditPaymentButton';
import { DateBubble } from '@web/components/DateBubble/DateBubble';
import { Announcements } from '@web/announcements/Announcements/Announcements';

import TextEditorAngular from '../../react/components/TextEditorAngular';
import EditArticleModal from '../../react/newsfeed/EditArticleModal';
import ArticleEditor from '../../react/newsfeed/ArticleEditor';
import r2a from '../../react/angularIntegration/r2a';
import ProgressButtonReact from '../../react/angularIntegration/components/ProgressButton.tsx';
import ButtonReact from '../../react/angularIntegration/components/Button.tsx';
import IconButtonReact from '../../react/angularIntegration/components/IconButton.tsx';
import InfoTooltip from '../../react/components/InfoTooltip.tsx';
import NpsScore from '../../react/components/npsScore/NpsScore.tsx';
import { PsatScore } from '../../react/components/psatScore/PsatScore.tsx';
import ExternalRate from '../../react/components/externalRate/ExternalRate.tsx';
import AfterSignupSurvey from '../../react/components/afterSignupSurvey/AfterSignupSurvey.tsx';
import TrialInfo from '../../react/onboarding/components/TrialInfo.tsx';
import CostsSaveBanner from '../../react/onboarding/components/CostsSaveBanner.tsx';
import Onboarding from '../../react/onboarding/components/OnboardingAngular.tsx';
import SettingsWithContext from '../../react/settings/SettingsWithContextAngular';
import GetMobileAppPopup from '../../react/components/getMobileAppPopup/GetMobileAppPopup.tsx';
import UnavailabilityListScreen from '../../react/unavailability/screens/UnavailabilityListScreenAngular.tsx';
import VerifyEmailCover from '../../react/components/VerifyEmailCover.tsx';
import OnboardingChecklistGuard from '../../react/onboarding/Checklist/OnboardingChecklistGuardAngular.tsx';
import AccountActivityScreenAngular from '../../react/settings/angularWrappers/AccountActivityScreenAngular.tsx';
import ToastModalContentAngular from '../../react/integrations/shiftScheduleImport/ToastModalContentAngular';
import ProfitWellAngular from '../../react/analytics/ProfitWellAngular';
import HappinessSurveyComponent from '../../react/components/happinessSurvey/HappinessSurvey';
import SubscriptionPreferenceSurvey from '../../react/components/subscriptionPreferenceSurvey/SubscriptionPreferenceSurvey'

import slingLoaderComponent from './components/slingLoader';

const commonModule = angular.module('sling.common', []);

commonModule.component('slingLoader', slingLoaderComponent);
commonModule.component('rProgressButton', r2a(ProgressButtonReact));
commonModule.component('rButton', r2a(ButtonReact));
commonModule.component(
  'rToggleSwitcher',
  r2a(ToggleSwitcher, [
    'value',
    'onChange',
    'disabled',
    '@enabledBackgroundColor',
    '@disabledBackgroundColor',
    'small',
  ])
);
commonModule.component('rIconButton', r2a(IconButtonReact));
commonModule.component('rOnboarding', r2a(Onboarding));
commonModule.component('rSettingsWithContext', r2a(SettingsWithContext));
commonModule.component('rAccountActivity', r2a(AccountActivityScreenAngular));
commonModule.component('rUnavailabilityListScreen', r2a(UnavailabilityListScreen));
commonModule.component('rTextEditor', r2a(TextEditorAngular));
commonModule.component(
  'rQuotedMessagePreview',
  r2a(QuotedMessagePreviewAngular, ['quotedMessage', '&removeQuotedMessage'])
);
commonModule.component(
  'rArticleEditor',
  r2a(ArticleEditor, [
    '&onSubmit',
    'pages',
    'canSelectPage',
    'personas',
    '&onContentChange',
    'initialValue',
    'initialAttachments',
    'initialPageId',
    'hideSubmit',
    '@placeholder',
    'resizable',
    '&showErrorToast',
  ])
);

commonModule.component(
  'rEditArticleModal',
  r2a(EditArticleModal, [
    'currentUser',
    'personas',
    '&onSubmit',
    'initialValue',
    'initialAttachments',
    'isOpen',
    '&onClose',
    'initialSticky',
    'pageName',
  ])
);
commonModule.component('rOnboardingChecklistGuard', r2a(OnboardingChecklistGuard));
commonModule.component('rToastModalContent', r2a(ToastModalContentAngular));
commonModule.component('rProfitWell', r2a(ProfitWellAngular));
commonModule.component('rAnnualPlanAnnouncement', r2a(AnnualPlanAnnouncementAngular));
commonModule.component('rIcalAnnouncement', r2a(ICalAnnouncementAngular));

commonModule.component('rInfoTooltip', r2a(InfoTooltip, ['@tip', '@place', 'attachToBody']));
commonModule.component(
  'rNpsScore',
  r2a(NpsScore, [
    'user',
    'usersCount',
    'locationsCount',
    'forceDisplay',
    '@subscriptionName',
    '&saveClientFlags',
    '&onClose',
  ])
);
commonModule.component(
  'rPsatScore',
  r2a(PsatScore, [
    'user',
    'usersCount',
    'locationsCount',
    'forceDisplay',
    '@subscriptionName',
    '&saveClientFlags',
    '&onClose',
  ])
);
commonModule.component(
  'rExternalRate',
  r2a(ExternalRate, ['user', 'hasShopifyIntegration', '&saveClientFlags'])
);
commonModule.component(
  'rSignupSurvey',
  r2a(AfterSignupSurvey, ['user', '&saveClientFlags', 'firstRun'])
);
commonModule.component(
  'rHappinessSurvey',
  r2a(HappinessSurveyComponent, [
    'user',
    'usersCount',
    'locationsCount',
    '&saveClientFlags',
    'onScheduleTab',
    'areShiftsPublished',
    'forceDisplay',
    '&onClose',
  ])
);
commonModule.component(
  'rSubscriptionPreferenceSurvey',
  r2a(SubscriptionPreferenceSurvey, [
    'user',
    'locationsCount',
    'totalUserCount',
    'joinedUserCount',
    'wasFreemiumSelected',
    '&saveClientFlags',
    'forceDisplay',
    '&onClose',
  ])
);
commonModule.component('rTrialInfo', r2a(TrialInfo, ['currentUser', '&goToBilling']));
commonModule.component(
  'rEditPaymentButton',
  r2a(EditPaymentButton, [
    'isManager',
    'subscriptionPaymentFailedDate',
    'subscriptionCreditCardExpiryDate',
    '&goToBilling',
  ])
);
commonModule.component(
  'rCostsSaveBanner',
  r2a(CostsSaveBanner, ['user', '&saveClientFlags', '&goToDetails'])
);
commonModule.component(
  'rGetMobileAppPopup',
  r2a(GetMobileAppPopup, [
    'user',
    'forceDisplay',
    'firstRun',
    '&saveClientFlags',
    '&onClose',
    '&updatePhone',
  ])
);
commonModule.component(
  'rVerifyEmailCover',
  r2a(VerifyEmailCover, ['userEmail', '&resendVerification', '&logout'])
);
commonModule.component('rAttachmentsPreview', r2a(AttachmentsPreview, ['attachments']));

commonModule.component(
  'rFoldableSearch',
  r2a(FoldableSearchAngularWrapper, [
    '&onSubmitSearch',
    '&onValueChange',
    'onCancelSearch',
    'initialValue',
    'submitEager',
  ])
);
commonModule.component(
  'rFoldableSearchBroaden',
  r2a(FoldableSearchBroadenAngularWrapper, [
    '&onSubmitSearch',
    '&onValueChange',
    'onCancelSearch',
    'initialValue',
    'submitEager',
  ])
);
commonModule.component('rDateBubble', r2a(DateBubble, ['date', '@bgColor']));
commonModule.component('rDashboardAnnouncements', r2a(Announcements));

export default commonModule.name;
